import { cn } from "@dd/ui";

interface RondaLogoProps {
  className?: string;
  inverted?: boolean;
}

function assetUrl(filename: string) {
  return window.rondaDesktop
    ? new URL(`./${filename}`, document.baseURI).href
    : `/${filename}`;
}

/**
 * Las dos marcas van como máscara y no como `<img>`: el archivo trae el
 * petróleo quemado adentro, y pintarlo con `bg-primary` es lo que deja que la
 * organización se retematice sin tener dos copias del SVG por color.
 */
function maskStyle(filename: string) {
  return {
    WebkitMaskImage: `url("${assetUrl(filename)}")`,
    maskImage: `url("${assetUrl(filename)}")`,
  };
}

/** The official Ronda wordmark, shared with the public landing. */
export function RondaLogo({ className, inverted = false }: RondaLogoProps) {
  return (
    <span
      role="img"
      aria-label="Ronda"
      className={cn(
        "ronda-wordmark inline-block h-7 w-[5.35rem] shrink-0",
        inverted ? "bg-primary-foreground" : "bg-primary",
        className,
      )}
      style={maskStyle("ronda-logo.svg")}
    />
  );
}

/** Isotipo oficial: los dos arcos de la o, la visita y el regreso. */
export function RondaMark({ className, inverted = false }: RondaLogoProps) {
  return (
    <span
      role="img"
      aria-label="Ronda"
      className={cn(
        "ronda-wordmark inline-block h-7 w-7 shrink-0",
        inverted ? "bg-primary-foreground" : "bg-primary",
        className,
      )}
      style={maskStyle("ronda-isotipo.svg")}
    />
  );
}
